import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class DataConcessionValidationService {
  constructor() {}

  public form: FormGroup;
  public formPureValue: any;

  public resetForm(): void {
    this.form.reset(this.formPureValue);
  }

  public saveFormState(): void {
    this.formPureValue = { ...this.form.value };
    this.resetForm();
  }
}
